<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        03.13
        <br />2019
      </span>
      <span class="tiel">美菜网开展数字经济，共同推进乡村振兴</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        前不久，美菜网作为中国餐饮供应链杰出服务商代表，参加了第五届世界互联网大会，这也是美菜网连续四次受邀参加了。此次大会在浙江乌镇举办。
        <br />
        <br />本届大会以"创造互信共治的数字世界——携手共建网络空间命运共同体"为主题，邀请了来自国内外国际组织成员、政府官员、互联网企业代表在内的1500位重要嘉宾。共同围绕创新发展、网络安全等议题进行探讨交流。
        <br />
        <br />本次大会上，创始人刘传军在"企业家高峰对话：新时代的数字经济"论坛中，与拼多多、知名企业代表一同就数字经济发展方向，促进消费升级等方面做了深入探讨。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/d010_1.png" width="640" />
      </p>

      <div class="tet-js">
        以下为部分发言内容：
        <br />
        <br />
      </div>

      <div class="title-bold">
        <span></span>数字经济发展助力乡村振兴
      </div>
      <div class="tet-js">
        目前，数字经济已经深刻融入我国经济社会各领域，以新一代信息技术为基础的数字经济影响着产业结构调整的路径和进程。
        <br />
        <br />长期以来，农产品从生产到销售的网络建设很不完善，对乡村经济发展和农业产业收入起到很大制约。
        <br />
        <br />而数字经济在农业领域的发展不但可以推动产业组织重组，而且可以升级产业链条，提高农业产业效率，大大降低了成本。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/d010_2.png" width="640" />
      </p>

      <div class="tet-js">
        作为B2B农产品电商企业的美菜网就是个典型，其自主研发的"两端一链一平台"模式，通过自建仓储、物流、配送及数百个技术系统，打通农产品产销渠道，缩短农产品中间环节，降低损耗，使农产品流通的衔接更为紧密。
        <br />
        <br />有效优化流程管理，降低中间成本，实现了从田间到餐桌的无缝对接。这种，需求端通过电商平台定制化订单，采购农产品；农民端根据订单需求生产规模化。既提高效率，又降低采买成本和决策风险，切实实现让农民生产无忧、生活无忧，助力乡村振兴。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/d010_3.png" width="640" />
        <br />
        <br />
      </p>
      <div class="title-bold">
        <span></span>规模化与大数据带来的消费升级
      </div>
      <div class="tet-js">
        数字经济的发展，对于产业链上游来说，通过电商平台订单农业的方式，让农民提高种植效率的同时，更带来了规模化生产。
        <br />
        <br />美菜网CEO刘传军分析发现，如果把消费者需求的农产品汇集在一起形成规模化，就能够改变传统的农产品流通方式，带来农产品流通的消费升级。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/d010_4.png" width="640" />
      </p>

      <div class="tet-js">
        而要让种类繁多的农产品与消费者需求衔接起来，家庭消费方式很难做到，而餐厅则有可能。如果一家餐厅订10斤土豆，那么10万家餐厅就是100万斤。
        <br />
        <br />那么需要美菜网找农民合作，农民有了订单，市场就有了保障。
        <br />
        <br />除此之外，互联网的快速渗透为餐饮行业提供了新消费方式，消费者需求的多样化，运营管理难度大，成本高利润低，供应链复杂难把控等问题在不断推动餐饮行业的数字经济发展。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/d010_5.png" width="640" />
      </p>

      <div class="tet-js">
        正是在这样的消费红利的趋势下，美菜网利用其大数据系统，形成可视化的数据模型，分析出消费者需求、口味、趋势，及时预订相应食材并推送菜品组合，满足餐厅的定制化需求。
        <br />
        <br />这样不仅带来了餐饮行业的消费升级，也推动了餐饮行业的变革。
        <br />
        <br />
      </div>

      <p align="center">
        <img src="@/assets/images/new-img/d010_6.png" width="640" />
      </p>

      <div class="tet-js">
        最后，刘传军表达了对数字经济发展的展望。
        <br />
        <br />他表示："将紧紧把握数字经济的历史性机遇，利用好数字经济赋能传统农业的新机遇，推进农业技术变革，实现农民身份转换，进而推动乡村振兴。餐饮行业中，在提高效率中提高产能和品质，改善食品消费环境，提高人民生活质量。"
        <br />
        <br />数字经济带来的不仅仅是生活上的变革，更为农村经济的进步带来了发展的契机，而美菜网正是抓住了这个契机，推动了传统农业的发展，而且实现了自身的升华，也将广大人民群众的生活水平提高了一个等级，实现定制化服务。
        <br />
        <br />
      </div>

      <!-- <div class="title-bold"><span></span>20年里的朴实无华</div> -->

      <!-- <p align="center"><img src="/assets/images/new-img/b011_1.jpg" width="640"></p>
        <div class="tet-js" style="text-align: center">
          牛角2018新零售创新标杆奖现场
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
